const __WEBPACK_NAMESPACE_OBJECT__ = require("@cybs-ui/components/lib/button");